<template>
  <div class=":ics: py-10 sm:py-16">
    <slot />
  </div>
</template>
